import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const WebSocketActions = createActionGroup({
  source: '[WebSocket]',
  events: {
    connectWebSocket: emptyProps(),
    disconnectWebSocket: emptyProps(),
    webSocketConnected: emptyProps(),
    webSocketDisconnected: emptyProps(),
    sendMessage: props<{ message: any }>(),
    messageReceived: props<{ message: any }>(),
    setConnectionId: props<{ connectionId: string }>(),
    setWorkspaceId: props<{ workspaceId: string | null }>(),
    unsubscribeFromWorkspace: emptyProps(),
    unsubscribeFromWorkspaceComplete: emptyProps(),
    setUserId: props<{ userId: string | null }>(),
    unsubscribeFromUser: emptyProps(),
    subscribeUserNotification: props<{ userId: string }>(),
    unSubscribeUserNotification: props<{ userId: string }>(),
  },
});
